import src from "IMAGE";
export default { src, width: 1000, height: 240, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
